import * as React from 'react';

import * as styles from './styles.css';
import { ControlButton } from '../../../../../../common/components/ControlButton';
import { ZoomIn } from '../../../../../../common/components/Icons';

export interface IZoomInButtonProps {
  map: YMaps.Map;
  onClick(): void;
}

export const ZoomInButton: React.FC<IZoomInButtonProps> = props => {
  const { map, onClick } = props;

  const handleZoomInClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();

      onClick();

      const zoom = map.getZoom();
      const [, maxZoom] = map.zoomRange.getCurrent();
      if (zoom >= maxZoom) {
        return;
      }

      return map.setZoom(zoom + 1);
    },
    [map, onClick],
  );

  return (
    <ControlButton className={styles['button']} onClick={handleZoomInClick}>
      <ZoomIn />
    </ControlButton>
  );
};
